<template>
    <div class="ppv2-flex ppv2-items-center ppv2-justify-between ppv2-gap-3 ppv2-w-full ppv2-flex-nowrap">
        <button
            v-if="isActionButtonVisible"
            class="ppv2-d-flex ppv2-items-center ppv2-gap-2 ppv2-flex-shrink-0"
            style="color: #3e4254"
            @click="handleBackClick"
        >
            <MoveLeft :size="18" />
            {{ $t('widgetIntegration.back') }}
        </button>

        <BaseButton
            v-if="isActionButtonVisible"
            variant="primary"
            :loading="submitting"
            @click="handleActionButtonClick"
            :customHeight="48"
            customClass="!ppv2-min-w-[160px] !ppv2-bg-[#7D2DBD] hover:!ppv2-bg-[#6b26a3] ms-auto ppv2-flex-shrink-0 ppv2-gap-2"
        >
            <Eye :size="18" />
            {{ buttonText }}
        </BaseButton>
    </div>
</template>

<script>
import BaseButton from '../../Shared/BaseButton.vue'
import { MoveLeft, Eye } from 'lucide-vue'
export default {
    name: 'WidgetFooter',
    components: {
        BaseButton,
        MoveLeft,
        Eye,
    },
    props: {
        isBackButtonVisible: {
            type: Boolean,
            default: false,
        },
        isActionButtonVisible: {
            type: Boolean,
            default: false,
        },
        submitting: {
            type: Boolean,
            default: false,
        },
        buttonText: {
            type: String,
            default: '',
        },
    },
    methods: {
        handleBackClick() {
            this.$emit('handleBackClick')
        },
        handleActionButtonClick() {
            this.$emit('handleActionButtonClick')
        },
    },
}
</script>
